import { createRoute, redirect } from '@tanstack/react-router'

import { ErrorFallback } from '@/app/error-boundary'
import { AppShell } from '@/app/shell/app-shell'
import { rootRoute } from './root'

export const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'app',
  beforeLoad: ({ context, location }) => {
    if (!context.isAuthenticated) {
      throw redirect({
        to: '/auth/login',
        search: { redirect: location.href },
      })
    }
  },
  component: AppShell,
  errorComponent: ErrorFallback,
})
